// Translations
import modelTransaction from '../components/model-transaction/translations/ar'

// Translation: Account > Billing > Recurring transactions (Arabic)
export default Object.freeze({
	components: { modelTransaction },
	fallback: {
		empty: '',
		unavailable: ''
	},
	title: '',
	transactionTypeItems: {
		ASSET_HOSTING: '',
		ASSET_REFUND: '',
		ASSET_USAGE: '',
		AUTO_TOP_UP: '',
		EXPIRABLE_CREDIT: '',
		PAY_OUT: '',
		RESERVE_ASSET_USAGE: '',
		SERVICE_ASSET_USAGE: '',
		SUBSCRIPTION: '',
		TOP_UP: '',
		TRANSFER: '',
		TRIAL_TOP_UP: '',
		UNSUBSCRIBE: ''
	}
})
